import React from 'react';
import { FormControlLabel, FormGroup, Switch, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'hooks';

const ToggleTemp = () => {
  const { convertTemp, setConvertTemp } = useSettings();
  const { t } = useTranslation();

  const onChange = (event) => {
    setConvertTemp(event.target.checked);
  };
  return (
    <FormGroup>
      <FormHelperText style={{ marginTop: 8 }}>{t('temperature')}</FormHelperText>
      <FormControlLabel
        style={{ minWidth: 125, marginLeft: 15 }}
        control={<Switch checked={convertTemp} size="small" onChange={onChange} name="temperature" />}
        label={convertTemp ? '°F' : '°C'}
      />
    </FormGroup>
  );
};
ToggleTemp.propTypes = {};
ToggleTemp.defaultProps = {};
export default ToggleTemp;
